module.exports = __webpack_public_path__ + "img/icon-pop_p.169421c1.svg";